module.exports = __webpack_public_path__ + "img/flt_pt_cors_bolts.prt.11f499f9.jpg";